import React from 'react';

export default class UpcomingItems extends React.Component {
	render() {
		return null;
	}
}
